module.exports = __webpack_public_path__ + "img/404.f82519e7.svg";